// extracted by mini-css-extract-plugin
export default {"button":"ReplyButton_button__jnhwT"};